// validationRules.js
export const RESTRICTIVE_VALIDATION_RULES = {
  companyName: {
    pattern: /^[a-zA-Z\s.]*$/,
    minLength: 2,
    maxLength: 100,
  },
  shareholderName: {
    pattern: /^[a-zA-Z\s.]*$/,
    minLength: 2,
    maxLength: 50,
  },
  claimantName: {
    pattern: /^[a-zA-Z\s.]*$/,
    minLength: 2,
    maxLength: 50,
  },
  beneficiaryAccount: {
    pattern: /^\d{0,18}$/, // allows 0-18 digits, validation below for min 10
    minLength: 10,
    maxLength: 18,
  },
  securityType: {
    pattern:  /^[A-Za-z]+$/, // any string but can be restricted further if needed
    minLength: 1,
  },
  numberOfShares: {
    pattern: /^\d*$/, // only numbers
    min: 1,
  },
  shareFaceValue: {
    pattern: /^\d*\.?\d{0,2}$/, // numbers with up to 2 decimals
    min: 0.01,
  },
  folioId: {
    pattern: /^[a-zA-Z0-9]*$/,
    maxLength: 20,
  },
  dematId: {
    pattern: /^IN?\d{0,14}$|^\d{0,16}$/, // 14 digits with IN or 16 digit
    maxLength: 16,
  },
  SRN: {
    pattern: /^I\d{0,10}$/,
    maxLength: 20,
  },
  transferDate: {
    // handled by date input type
  },
  status: {
    pattern: /^.*$/, // any string
    minLength: 1,
  },
  caseType: {
    // handled by select/multiselect component
  },
  claimableAmount: {
    pattern: /^\d*\.?\d{0,2}$/, // numbers with up to 2 decimals
    min: 0,
  },
};

export const DIVIDEND_RESTRICTIVE_VALIDATION_RULES = {
  financialYear: {
    pattern: /^\d{0,4}-?\d{0,4}$/, // allow user to build up correct year
    maxLength: 9,
  },
  paymentDate: {
    // handled by date input type
  },
  warrantNo: {
    pattern: /^[a-zA-Z0-9]*$/,
    minLength: 3,
    maxLength: 20,
  },
  amount: {
    pattern: /^\d*\.?\d{0,2}$/, // numbers with up to 2 decimals
    min: 0.01,
  },
};